// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import React, { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const InstallExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 37 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect x={0.666016} width={36} height={36} rx={8} fill="#5E7398" />
				<g opacity={0.8}>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M20.4941 10.0859C19.8971 9.95272 19.2879 9.88205 18.6762 9.875C18.0493 9.88221 17.4394 9.95285 16.8417 10.0858C16.5809 10.1438 16.3858 10.3611 16.3562 10.6266L16.2145 11.898C16.1738 12.2618 15.9628 12.5851 15.6458 12.7689C15.3275 12.9549 14.9415 12.9771 14.6057 12.8298L13.4387 12.3171C13.196 12.2105 12.9123 12.2686 12.7311 12.4622C11.8876 13.363 11.2594 14.4435 10.8938 15.6221C10.8149 15.8765 10.9059 16.1529 11.1203 16.3107L12.1558 17.0727C12.4513 17.2898 12.6256 17.6342 12.6256 18.0004C12.6256 18.3666 12.4513 18.7109 12.1562 18.9277L11.1201 19.6911C10.9059 19.8488 10.8151 20.1249 10.8937 20.379C11.2587 21.5588 11.8865 22.6404 12.73 23.5424C12.911 23.7361 13.1945 23.7944 13.4373 23.688L14.6095 23.1745C14.9437 23.0286 15.3281 23.05 15.6447 23.2325C15.9613 23.415 16.1725 23.7369 16.2138 24.1L16.3545 25.3703C16.3836 25.6327 16.5743 25.8485 16.831 25.9096C18.0381 26.1968 19.2957 26.1968 20.5027 25.9096C20.7595 25.8485 20.9502 25.6327 20.9793 25.3703L21.1202 24.0981C21.1604 23.7343 21.3713 23.4114 21.6881 23.2283C22.005 23.0452 22.39 23.0237 22.7254 23.1704L23.8973 23.6838C24.14 23.7902 24.4234 23.7319 24.6044 23.5384C25.4474 22.6374 26.0753 21.5571 26.4408 20.3786C26.5196 20.1243 26.4288 19.8481 26.2145 19.6903L25.1791 18.9274C24.8833 18.7101 24.709 18.3658 24.709 17.9996C24.709 17.6333 24.8833 17.289 25.1784 17.0722L26.213 16.3096C26.4272 16.1517 26.5179 15.8755 26.4391 15.6213C26.0734 14.4426 25.4453 13.3622 24.6018 12.4613C24.4206 12.2678 24.1369 12.2097 23.8942 12.3163L22.727 12.829C22.5809 12.8936 22.4246 12.9266 22.2665 12.9263C21.6785 12.9257 21.1853 12.4832 21.121 11.899L20.9792 10.6266C20.9496 10.3613 20.7547 10.144 20.4941 10.0859ZM18.666 22C20.8752 22 22.666 20.2091 22.666 18C22.666 15.7909 20.8752 14 18.666 14C16.4569 14 14.666 15.7909 14.666 18C14.666 20.2091 16.4569 22 18.666 22Z"
						fill="white"
					/>
				</g>
			</Svg>
		);
	}
);
InstallExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default InstallExtension;
